// src/components/Navbar.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';

export default function Navbar({ onSearchChange, onCreate }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    onSearchChange(e.target.value);  // Appel de la fonction passée en props
  };

  return (
    <div className="flex flex-col lg:flex-row items-center justify-between p-6 w-full">
      {/* Conteneur principal */}
      <div className="flex items-center justify-between w-full">
        {/* Barre de recherche à gauche */}
        
        <h2 className="text-2xl font-bold mb-4 text-terrecuite">Organisations</h2>
        <div className="flex items-center bg-white  border-terrecuite shadow-sm rounded-sm px-4 py-2 w-full max-w-96 transition-all duration-300 focus-within:ring-2 focus-within:ring-terrecuite">
          <Search className="w-5 h-5 text-terrecuite" />
          <input
            type="text"
            placeholder="Rechercher une organisation..."
            value={searchTerm}
            onChange={handleSearchChange}  // Gérer le changement de recherche
            className="ml-2 w-full outline-none bg-transparent text-terrecuite placeholder-terrecuite/70  rounded-sm px-2 py-1"
          />
        </div>

        {/* Bouton de création à droite */}
        <button
          onClick={onCreate}
          className="bg-terrecuite hover:bg-terrecuite/80 text-white font-semibold px-5 py-3 rounded-lg shadow-lg transition-colors duration-300 focus:ring-2 focus:ring-terrecuite focus:ring-opacity-50"
        >
          <Link to="/admin/organisations/create" className="flex items-center">
            + Créer une organisation
          </Link>
        </button>
      </div>
    </div>
  );
}
